// Copyright (c) 2016 Deere & Company

import ResponsibleDealer from '../../../reports/responsible-dealer/state-connector';

export default {
    component: ResponsibleDealer,
    name: 'RESPONSIBLE_DEALER',
    path: 'responsible-dealer-report'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/responsible-dealer.js